(() => {
  const storageKey = 'bb:support-mode';
  const params = new URLSearchParams(window.location.search);
  const requested = params.get('support');
  let enabled = false;

  try {
    if (requested === '1') sessionStorage.setItem(storageKey, '1');
    if (requested === '0') sessionStorage.removeItem(storageKey);
    enabled = sessionStorage.getItem(storageKey) === '1';
  } catch (_error) {
    enabled = requested === '1';
  }

  const cleanUrl = (id) => {
    const canonical = document.querySelector('link[rel="canonical"]')?.href;
    const base = new URL(window.location.pathname, canonical || window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);
    for (const key of ['variant', 'view', 'bb_pickup_location', 'bb_quantity', 'bb_extra']) {
      const value = currentParams.get(key);
      if (value) base.searchParams.set(key, value);
    }
    base.hash = id;
    return base.href;
  };

  const isStableId = (id) => /^bb-[a-z0-9-]+$/i.test(id);
  const supportKey = (wrapper, index) => {
    const key = wrapper.id.split('__').at(-1) || `sectie-${index + 1}`;
    return `support-${key.toLowerCase().replace(/[^a-z0-9-]/g, '-')}`;
  };

  const anchorFor = (wrapper, heading, index) => {
    let ancestor = heading.parentElement;
    while (ancestor && ancestor !== wrapper.parentElement) {
      if (isStableId(ancestor.id)) return ancestor;
      ancestor = ancestor.parentElement;
    }

    let id = supportKey(wrapper, index);
    let suffix = 2;
    const previous = heading.previousElementSibling;
    while (document.getElementById(id) && previous?.id !== id) {
      id = `${supportKey(wrapper, index)}-${suffix++}`;
    }
    let anchor = previous?.id === id && previous.classList.contains('bb-support-anchor') ? previous : null;
    if (!anchor) {
      anchor = document.createElement('span');
      anchor.className = 'bb-support-anchor';
      anchor.id = id;
      anchor.setAttribute('aria-hidden', 'true');
      heading.before(anchor);
    }
    return anchor;
  };

  const copy = async (url, status) => {
    try {
      await navigator.clipboard.writeText(url);
      status.textContent = 'Link gekopieerd';
    } catch (_error) {
      window.prompt('Kopieer deze sectielink:', url);
      status.textContent = 'Selecteer en kopieer de link';
    }
  };

  const addRow = (target, heading, id, status) => {
    if (target.previousElementSibling?.classList.contains('bb-support-row')) return;
    const row = document.createElement('div');
    row.className = 'bb-support-row';
    row.setAttribute('data-bb-support-for', id);

    const title = document.createElement('span');
    title.className = 'bb-support-row__title';
    title.textContent = heading.textContent.trim() || 'Sectie';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bb-support-row__copy';
    button.textContent = 'Kopieer sectielink';
    button.setAttribute('aria-label', `Kopieer link naar ${title.textContent}`);
    button.dataset.bbSupportUrl = cleanUrl(id);
    button.addEventListener('click', () => {
      button.dataset.bbSupportUrl = cleanUrl(id);
      copy(button.dataset.bbSupportUrl, status);
    });

    row.append(title, button);
    target.before(row);
  };

  const alignHash = () => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    const target = id && document.getElementById(id);
    if (!target?.dataset.bbSupportTarget) return;
    const headerBottom = document.querySelector('.bb-site-header')?.getBoundingClientRect().bottom || 0;
    const top = window.scrollY + target.getBoundingClientRect().top - Math.max(0, headerBottom) - 24;
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
  };

  const init = () => {
    if (window.Shopify?.designMode) return;
    const main = document.getElementById('MainContent');
    if (!main) return;

    let status;
    if (enabled) {
      const bar = document.createElement('div');
      bar.className = 'bb-support-bar';
      const label = document.createElement('span');
      label.textContent = 'Supportmodus aan';
      status = document.createElement('span');
      status.className = 'bb-support-bar__status';
      status.setAttribute('role', 'status');
      const exit = document.createElement('button');
      exit.type = 'button';
      exit.className = 'bb-support-bar__exit';
      exit.textContent = 'Afsluiten';
      exit.addEventListener('click', () => {
        try { sessionStorage.removeItem(storageKey); } catch (_error) { /* URL remains the fallback. */ }
        const url = new URL(window.location.href);
        url.searchParams.delete('support');
        window.location.assign(url.href);
      });
      bar.append(label, status, exit);
      document.body.append(bar);
    }

    const seenHeadings = new Set();
    const wrappers = Array.from(main.querySelectorAll(':scope > .shopify-section'));
    wrappers.forEach((wrapper, index) => {
      const heading = wrapper.querySelector('h1, h2');
      if (!heading || wrapper.hidden || !heading.getClientRects().length) return;
      const anchor = anchorFor(wrapper, heading, index);
      anchor.dataset.bbSupportTarget = '1';
      seenHeadings.add(heading);
      if (enabled) addRow(wrapper, heading, anchor.id, status);
    });

    main.querySelectorAll('[id^="bb-"]').forEach((target) => {
      if (!isStableId(target.id) || target.hidden) return;
      const heading = target.querySelector('h2');
      if (!heading || seenHeadings.has(heading) || !heading.getClientRects().length) return;
      target.dataset.bbSupportTarget = '1';
      seenHeadings.add(heading);
      if (enabled) addRow(target, heading, target.id, status);
    });

    if (window.location.hash) {
      requestAnimationFrame(alignHash);
      window.addEventListener('load', alignHash, { once: true });
    }
    window.addEventListener('hashchange', () => requestAnimationFrame(alignHash));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
